const apiUrl = __BUILDENV__ === 'prod' ? 'https://merch.yishengzhan.cn/api/' : 'https://t.merch.yishengzhan.cn/api/';
const webUrl = __BUILDENV__ === 'prod' ? 'https://merch.yishengzhan.cn' : 'https://t.merch.yishengzhan.cn';
export { apiUrl, webUrl };



// WEBPACK FOOTER //
// ./src/common/base/constant.js